import type { WordGardenConfig } from '../minigames/word-garden/WordGardenConfig.js';

export const WORD_GARDEN_CONTEXT_1: WordGardenConfig = {
  id: 'word-garden-context-1',
  skillId: 'literacy-vocabulary-context',
  skillKind: 'context-clues',
  title: 'The Moonflower’s Meaning',
  sentence: 'The moonflower was delicate, so Cosmo carried it gently with both hands.',
  targetWord: 'delicate',
  choices: [
    { id: 'easy-to-damage', meaning: 'easy to damage' },
    { id: 'bright-at-night', meaning: 'bright at night' },
    { id: 'covered-in-thorns', meaning: 'covered in sharp thorns' },
  ],
  correctChoiceId: 'easy-to-damage',
  hints: [
    { message: 'Look at what Cosmo does before and after the word.' },
    {
      message: 'This part gives a helpful clue.',
      highlightText: 'carried it gently with both hands',
    },
    { message: 'Which meaning explains why Cosmo handled the flower so carefully?' },
  ],
  completionWorldEvent: 'word-garden-bloom-1',
  successMessage: 'The moonflower remembers its meaning, and the Word Garden blooms!',
};
